// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\HomepageSettings.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { HomepageBannerSettings as _HomepageBannerSettings, HomepageBannerSettingsData as _HomepageBannerSettingsData, HomepageBannerSettingsOptions as _HomepageBannerSettingsOptions } from 'data/models/HomepageSettings';
import { HomepageTabVisibility } from 'server/enums/HomepageTabVisibility';

// HomepageSettingsData is the class that HomepageSettings serializes to/from
export interface HomepageSettingsData {
	
	
    Banner : _HomepageBannerSettingsData;
    CruiseVisibility : HomepageTabVisibility;
    InPortVisibility : HomepageTabVisibility;
    MapVisibility : HomepageTabVisibility;
    MovementsVisibility : HomepageTabVisibility;
}

// HomepageSettingsOptions is the class which may be passed to the HomepageSettings constructor to define optional initial data values
export interface HomepageSettingsOptions {
	
	
    Banner? : _HomepageBannerSettingsOptions;
    CruiseVisibility? : HomepageTabVisibility;
    InPortVisibility? : HomepageTabVisibility;
    MapVisibility? : HomepageTabVisibility;
    MovementsVisibility? : HomepageTabVisibility;
}

export class HomepageSettings {
	
	
    public Banner : _HomepageBannerSettings;
    public CruiseVisibility : DataSignal<HomepageTabVisibility>;
    public InPortVisibility : DataSignal<HomepageTabVisibility>;
    public MapVisibility : DataSignal<HomepageTabVisibility>;
    public MovementsVisibility : DataSignal<HomepageTabVisibility>;

    constructor();
    constructor(data : HomepageSettingsOptions);
    constructor(data: HomepageSettingsOptions | null = null) {
	    
	    
        this.Banner = data && data.Banner !== undefined ? new _HomepageBannerSettings(data.Banner) : new _HomepageBannerSettings();
        this.CruiseVisibility = jsonableObservable(S.value<HomepageTabVisibility>(data && data.CruiseVisibility !== undefined ? data.CruiseVisibility : 0));
        this.InPortVisibility = jsonableObservable(S.value<HomepageTabVisibility>(data && data.InPortVisibility !== undefined ? data.InPortVisibility : 0));
        this.MapVisibility = jsonableObservable(S.value<HomepageTabVisibility>(data && data.MapVisibility !== undefined ? data.MapVisibility : 0));
        this.MovementsVisibility = jsonableObservable(S.value<HomepageTabVisibility>(data && data.MovementsVisibility !== undefined ? data.MovementsVisibility : 0));
    }

    static key(obj : HomepageSettings) {
        return ;
    }
    
    static dataKey(obj : HomepageSettingsOptions) {
        return ;
    }

    static update(obj : HomepageSettings, data : HomepageSettingsOptions) {
        S.freeze(() => {
	        
	        
            if (data.Banner !== undefined) _HomepageBannerSettings.update(obj.Banner, data.Banner);
            if (data.CruiseVisibility !== undefined) obj.CruiseVisibility(data.CruiseVisibility);
            if (data.InPortVisibility !== undefined) obj.InPortVisibility(data.InPortVisibility);
            if (data.MapVisibility !== undefined) obj.MapVisibility(data.MapVisibility);
            if (data.MovementsVisibility !== undefined) obj.MovementsVisibility(data.MovementsVisibility);
        });
    }
}

// HomepageBannerSettingsData is the class that HomepageBannerSettings serializes to/from
export interface HomepageBannerSettingsData {
    Url : string | null;
	
	
    TextColor : string | null;
    TextShadowColor : string | null;
}

// HomepageBannerSettingsOptions is the class which may be passed to the HomepageBannerSettings constructor to define optional initial data values
export interface HomepageBannerSettingsOptions {
    Url? : string | null;
	
	
    TextColor? : string | null;
    TextShadowColor? : string | null;
}

export class HomepageBannerSettings {
    public Url : DataSignal<string | null>;
	
	
    public TextColor : DataSignal<string | null>;
    public TextShadowColor : DataSignal<string | null>;

    constructor();
    constructor(data : HomepageBannerSettingsOptions);
    constructor(data: HomepageBannerSettingsOptions | null = null) {
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
	    
        this.TextColor = jsonableObservable(S.value<string | null>(data && data.TextColor !== undefined ? data.TextColor : null));
        this.TextShadowColor = jsonableObservable(S.value<string | null>(data && data.TextShadowColor !== undefined ? data.TextShadowColor : null));
    }

    static key(obj : HomepageBannerSettings) {
        return ;
    }
    
    static dataKey(obj : HomepageBannerSettingsOptions) {
        return ;
    }

    static update(obj : HomepageBannerSettings, data : HomepageBannerSettingsOptions) {
        S.freeze(() => {
            if (data.Url !== undefined) obj.Url(data.Url);
	        
	        
            if (data.TextColor !== undefined) obj.TextColor(data.TextColor);
            if (data.TextShadowColor !== undefined) obj.TextShadowColor(data.TextShadowColor);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/HomepageSettings.ts